module.exports = __webpack_public_path__ + "img/cup.9d9c5955.jpg";